module.exports = __webpack_public_path__ + "static/media/clearvin.020b3b46.png";